module.exports = __webpack_public_path__ + "img/chevron-right-red.6f281d19.svg";